// removed by extract-text-webpack-plugin
module.exports = {"paymentRequest":"_38Dac9UqC-vTdZbOJrbihb","info":"_1hqbSn4tERhHDlyUehXXPf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/components/PaymentRequestForm.mod.css
// module id = 1061
// module chunks = 0